/**
 * @desc 获取商户是否在支付方式黑名单
 */

import * as defs from '../../baseClass'
import axios from '@/services/request'

export class Params {
  /** merchantNo */
  merchantNo: string
}

export const init = new defs.SimpleResponse()

export async function request(params) {
  return axios({
    url: '/api/scp-cashier-business/common/checkIfPaymentMethodBlackList',
    params,
    method: 'get',
  })
}
